const renderRoomdenCountryFlags = (root = document) => {
  root.querySelectorAll('[data-country-flag]').forEach((flag) => {
    const countryCode = flag.dataset.countryFlag?.trim().toUpperCase();

    if (!countryCode || !/^[A-Z]{2}$/.test(countryCode)) return;

    flag.textContent = [...countryCode]
      .map((letter) => String.fromCodePoint(127397 + letter.charCodeAt(0)))
      .join('');
  });
};

renderRoomdenCountryFlags();

document.addEventListener('shopify:section:load', (event) => {
  renderRoomdenCountryFlags(event.target);
});
